import { DialogProps } from '@mui/material'
import { ImgHTMLAttributes, MouseEvent } from 'react'
import { useDialog } from '../hooks'
import ImagePreviewDialog from './ImagePreviewDialog'

interface ImageWithPreviewProps extends ImgHTMLAttributes<HTMLImageElement> {
  class?: string
  previewMaxWidth?: DialogProps['maxWidth']
}

export default function ImageWithPreview({
  src,
  class: classAttr,
  className,
  onClick,
  previewMaxWidth = 'lg',
  ...imgProps
}: ImageWithPreviewProps): JSX.Element {
  const { open, openDialog, closeDialog } = useDialog()

  function handleClick(event: MouseEvent<HTMLImageElement>): void {
    onClick?.(event)

    if (event.defaultPrevented || !src) {
      return
    }

    openDialog()
  }

  return (
    <>
      <img
        src={src}
        className={className ?? classAttr}
        onClick={handleClick}
        style={{ cursor: 'pointer', maxWidth: '100%', height: 'auto', ...imgProps.style }}
        {...imgProps}
      />
      <ImagePreviewDialog
        open={open && Boolean(src)}
        imageUrl={typeof src === 'string' ? src : undefined}
        onClose={closeDialog}
        maxWidth={previewMaxWidth}
      />
    </>
  )
}
